<template>
  <div class="order-list-page">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>

    <v-layout v-else wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 pa-5>
        
        <!-- Page Header -->
        <div class="page-header mb-5">
          <div class="header-left">
            <v-btn icon @click="$router.go(-1)" class="mr-3" style="background: white; border: 1px solid #e2e8f0;">
              <v-icon color="#64748b" size="20">mdi-arrow-left</v-icon>
            </v-btn>
            <div class="header-icon-wrap">
              <v-icon color="white" size="22">mdi-card-account-mail-outline</v-icon>
            </div>
            <div>
              <h2 class="page-title">Message Details</h2>
            </div>
          </div>
          <div class="header-actions">
            <!-- Reply Button -->
            <v-btn
              v-if="user.status !== 'Replied'"
              depressed
              class="action-approve-btn"
              @click="dialog = true"
            >
              <v-icon left size="16">mdi-reply</v-icon>
              <span>Reply</span>
            </v-btn>
            <span v-else class="status-badge status-delivered ml-2">
              <v-icon left size="14" class="mr-1">mdi-check-all</v-icon> Replied
            </span>
          </div>
        </div>

        <!-- Main Content -->
        <v-row>
          <v-col cols="12" md="4">
            <!-- Sender Info Card -->
            <v-card class="modern-card h-100" elevation="0">
              <div class="card-toolbar py-3 px-4">
                <div class="toolbar-left">
                  <v-icon color="#3ea56e" class="mr-2">mdi-account-circle-outline</v-icon>
                  <span class="toolbar-title">Sender Information</span>
                </div>
              </div>
              <v-divider></v-divider>
              <div class="pa-5">
                <div class="info-block mb-4">
                  <span class="info-label">Name</span>
                  <div class="info-value mt-1">{{ user.name || '-' }}</div>
                </div>
                <div class="info-block mb-4">
                  <span class="info-label">Email</span>
                  <div class="info-value mt-1 text-primary-link" style="color: #228be6; cursor: pointer;">{{ user.email || '-' }}</div>
                </div>
                <div class="info-block mb-4">
                  <span class="info-label">Received On</span>
                  <div class="info-value mt-1">{{ formatDate(user.create_date) }}</div>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="8">
            <div class="d-flex flex-column h-100">
              <!-- Message Content Card -->
              <v-card class="modern-card flex-grow-1" :class="{'mb-4': user.reply}" elevation="0">
                <div class="card-toolbar py-3 px-4">
                  <div class="toolbar-left">
                    <v-icon color="#3ea56e" class="mr-2">mdi-text-box-outline</v-icon>
                    <span class="toolbar-title">Message Content</span>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="pa-5 h-100">
                  <div class="message-box h-100">
                    {{ user.message || 'No message provided.' }}
                  </div>
                </div>
              </v-card>

              <!-- Reply Content Card -->
              <v-card v-if="user.reply" class="modern-card" style="border-color: #86efac !important;" elevation="0">
                <div class="card-toolbar py-3 px-4" style="background: #f0fdf4;">
                  <div class="toolbar-left">
                    <v-icon color="#16a34a" class="mr-2">mdi-reply-all-outline</v-icon>
                    <span class="toolbar-title" style="color: #166534;">Our Reply</span>
                  </div>
                </div>
                <v-divider style="border-color: #bbf7d0 !important;"></v-divider>
                <div class="pa-5">
                  <div class="message-box" style="background: #ffffff; border-color: #bbf7d0;">
                    {{ user.reply }}
                  </div>
                </div>
              </v-card>
            </div>
          </v-col>
        </v-row>

      </v-flex>
    </v-layout>

    <!-- Reply Modal -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card class="modern-card">
        <v-card-title class="text-h6 pt-5 pb-3">Reply to {{ user.name }}</v-card-title>
        <v-card-text class="pt-2 text-body-1">
          <v-textarea
            label="Reply Message"
            v-model="replyMsg"
            outlined
            class="modern-input"
            hide-details
            rows="6"
            placeholder="Type your response here..."
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            class="text-capitalize px-4"
            style="border-radius: 8px; font-weight: 600;"
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#3ea56e"
            class="text-capitalize px-4 white--text"
            depressed
            style="border-radius: 8px; font-weight: 600;"
            @click="replay"
          >
            Send Reply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar for Notifications -->
    <v-snackbar
      v-model="showSnackBar"
      color="success"
      :timeout="3000"
      bottom
      right
    >
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="showSnackBar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      msg: null,
      ServerError: false,
      showSnackBar: false,
      user: {},
      appLoading: false,
      dialog: false,
      replyMsg: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/contactus/view/details/" + this.$route.query.id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.user = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    replay() {
      if(!this.replyMsg) return;
      var data = {};
      data["id"] = this.$route.query.id;
      data["replyMsg"] = this.replyMsg;
      
      this.appLoading = true;
      axios({
        url: "/contactus/reply",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.dialog = false;
            this.msg = "Replied Successfully";
            this.showSnackBar = true;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    formatDate(item) {
      if(!item) return "";
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style scoped>
/* Page Wrapper */
.order-list-page {
  background: #f5f6fa;
  min-height: 100vh;
  font-family: poppinsmedium, sans-serif;
}

/* Page Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3ea56e, #2d8257);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.35);
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}

/* Main Card */
.modern-card {
  border-radius: 16px !important;
  border: 1px solid #ebebeb !important;
  overflow: hidden;
  background: #ffffff;
}

/* Card Toolbar */
.card-toolbar {
  background: #fdfdfd;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.toolbar-left {
  display: flex;
  align-items: center;
}
.toolbar-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

/* Info Blocks */
.info-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.info-label {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.info-value {
  font-size: 14px;
  color: #374151;
  font-weight: 600;
}

/* Message Box */
.message-box {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  font-size: 14px;
  color: #475569;
  line-height: 1.6;
  white-space: pre-wrap;
  min-height: 120px;
}

/* Action Button */
.action-approve-btn {
  border-radius: 10px !important;
  background-color: #e8f5e9 !important;
  color: #2d8257 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  padding: 8px 18px !important;
  height: 38px !important;
  border: 1px solid #c8e6c9 !important;
  transition: all 0.2s ease !important;
}
.action-approve-btn:hover {
  background-color: #3ea56e !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.25) !important;
  border-color: #3ea56e !important;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  border-width: 1px;
  border-style: solid;
}
.status-delivered {
  background-color: #e8f7ee;
  color: #3ea56e;
  border-color: #3ea56e33;
}

.modern-input ::v-deep .v-input__slot {
  border-radius: 10px !important;
  font-size: 13px;
  border-color: #e2e8f0 !important;
}
</style>
